import { UserModule } from '@/store/module/user'
import { Message } from 'element-ui'
import setting from '@/setting'

export const checkAuth = function (authKey: number) {
  return function (target: any, key: any, descriptor: any) {
    const fn = descriptor.value
    descriptor.value = function (...arg: any) {
      if (UserModule.userInfo.roleID === 1) {
        fn.apply(this, arg)
      } else {
        const menuId = localStorage.getItem('menuId')
        const subMenuId = localStorage.getItem('subMenuId')
        if (
          UserModule.userInfo.right?.includes(subMenuId + '' + authKey) ||
          UserModule.userInfo.right?.includes(menuId + '' + authKey)
        ) {
          fn.apply(this, arg)
        } else {
          Message.error(`暂无${setting.OPERATION_MAP.get(authKey)}权限` || '暂无权限')
        }
      }
    }
  }
}
